/**
 * 地址输入表单
 * 且会在 第二步数据返回显示
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 * @param deliveryOrderId 编辑时传入此id,等同于将以有否 deliveryOrderId 判断是否编辑状态
 **/
import React from "react";
import FormFormat from '@/components/FormFormat/FormFormat';

export default class AddressForm extends React.Component{
    static propTypes = {
    }
    static defaultProps = {
    };
    constructor(props) {
        super(props);
        this.state = {
            fieldList:[
                {
                    name:'contactName',  // 收件人全名
                    cnTitleId:'ShouJianRenQuanMing',
                    required: true,
                    maxLength:128,
                },
                {
                    name:'taxRegistrationNo',  // 税务号/护照信息
                    cnTitleId:'ShuiWuHaoHuZhaoXinXi',
                    cnTitle:"税务号/护照信息",
                    // ShuiWuHaoHuZhaoXinXiTiShi
                    cnPlaceholder:'收件人是法人，填写税务号；是个人，填写护照信息',
                    cnPlaceholderId:'ShuiWuHaoHuZhaoXinXiTiShi',
                    required: true,
                    maxLength:128,
                },
                {
                    name:'contactMobile',  // 联系电话
                    nameTelephoneCode:"contactTelCode",
                    cnTitleId:'LianXiDianHua',
                    required: true,
                    type:'AreaPhone',
                },
                {
                    name:'cityName',
                    cnTitleId:'ShouJianRenSuoZaiChengShi',
                    cnTitle:"收件人所在城市",
                    cnPlaceholder:'请输入城市名称',
                    cnPlaceholderId:'QingShuRuChengShiMinCheng',
                    required: true,
                    maxLength:128,
                },
                {
                    name:'terminalName',
                    cnTitleId:'YunShuGongSiZhongDianZhan',
                    cnTitle:"运输公司终点站",
                    cnPlaceholder:'请注明所需的运输公司终点站',
                    cnPlaceholderId:'QingZhuMingSuoXuDeYunShuGongSiZhongDianZhan',
                    required: true,
                    maxLength:128,
                },
                {
                    name:'deliveryAddress',
                    cnTitleId:'ChengShiJiaoHuoDiZhi',
                    cnTitle:"城市交货地址",
                    type:"TextArea",
                    minRows:3,
                    cnPlaceholder:'送货上门',
                    cnPlaceholderId:'SongHuoShangMen',
                    maxLength:512,
                },
                {
                    name:'remark',
                    cnTitle:'备注',
                    cnTitleId:'BeiZhu',
                    type:"TextArea",
                    minRows:3,
                    maxLength:512,
                },
            ],
        }
    }
    async save(){
        return await this.onRefFormFormatAddress.handleOK();
    }
    onRefFormAddress = (ref) =>  this.onRefFormFormatAddress = ref;
    componentDidMount() {
        if( this.props.onRef)this.props.onRef(this);
    };
    render() {
        const {fromInitialValues } = this.props;
        const { fieldList } = this.state;

        return (<FormFormat onRef={this.onRefFormAddress}
                            options={fieldList}
                            formItemLayout={null}
                            formLayout = "vertical"
                            initialValues={fromInitialValues} />);
    }
}

